import React, { useState } from 'react';
export const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipo: 'retiros',
    actualizaciones: 'si',
    mensaje: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setForm({
        nombre: '',
        email: '',
        telefono: '',
        tipo: 'retiros',
        actualizaciones: 'si',
        mensaje: ''
      });
    }, 3000);
  };
  if (submitted) {
    return <div className="text-center py-16 border-t border-taupe" data-id="element-13">
        <p className="text-3xl font-serif italic text-sage mb-3" data-id="element-14">Gracias.</p>
        <p className="text-sm text-stone-light" data-id="element-15">Te responderemos en breve.</p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="border border-taupe bg-white p-5 sm:p-10 md:p-14 max-w-2xl mx-auto space-y-7 sm:space-y-8" data-id="element-16">
      <FormField label="Nombre" name="nombre" value={form.nombre} onChange={handleChange} required data-id="element-17" />
      <FormField label="Email" name="email" type="email" value={form.email} onChange={handleChange} required data-id="element-18" />
      <FormField label="Teléfono" name="telefono" type="tel" value={form.telefono} onChange={handleChange} required validationMessage="El teléfono es obligatorio" data-id="element-19" />

      <div data-id="element-20">
        <label className="block text-xs uppercase tracking-widest text-stone-light mb-4" data-id="element-21">
          Tipo de información
        </label>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8" data-id="element-22">
          <RadioOption name="tipo" value="retiros" current={form.tipo} onChange={handleChange} label="Retiros" data-id="element-23" />
          <RadioOption name="tipo" value="celebraciones" current={form.tipo} onChange={handleChange} label="Otras celebraciones" data-id="element-24" />
        </div>
      </div>

      <div data-id="element-25">
        <label className="block text-xs uppercase tracking-widest text-stone-light mb-4" data-id="element-26">
          ¿Quieres recibir actualizaciones de Mas Claror?
        </label>
        <div className="flex gap-8" data-id="element-27">
          <RadioOption name="actualizaciones" value="si" current={form.actualizaciones} onChange={handleChange} label="Sí" data-id="element-28" />
          <RadioOption name="actualizaciones" value="no" current={form.actualizaciones} onChange={handleChange} label="No" data-id="element-29" />
        </div>
      </div>

      <div data-id="element-30">
        <label className="block text-xs uppercase tracking-widest text-stone-light mb-4" data-id="element-31">
          Cuéntanos qué estás buscando
        </label>
        <textarea name="mensaje" value={form.mensaje} onChange={handleChange} rows={4} className="w-full bg-transparent border-b border-taupe focus:border-stone outline-none py-3 text-stone resize-none transition-colors" data-id="element-32" />
      </div>

      <button type="submit" className="w-full bg-stone text-cream py-4 text-xs uppercase tracking-widest hover:bg-forest transition-colors duration-500" data-id="element-33">
        Enviar
      </button>
    </form>;
};
const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  validationMessage
}: {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  validationMessage?: string;
}) => {
  const handleInvalid = (e: React.InvalidEvent<HTMLInputElement>) => {
    if (validationMessage) {
      e.currentTarget.setCustomValidity(validationMessage);
    }
  };
  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    if (validationMessage) {
      e.currentTarget.setCustomValidity('');
    }
  };
  return <div data-id="element-34">
      <label className="block text-xs uppercase tracking-widest text-stone-light mb-3" data-id="element-35">
        {label} {required && <span className="text-clay" data-id="element-36">*</span>}
      </label>
      <input type={type} name={name} value={value} onChange={onChange} onInvalid={handleInvalid} onInput={handleInput} required={required} className="w-full bg-transparent border-b border-taupe focus:border-stone outline-none py-3 text-stone transition-colors" data-id="element-37" />
    </div>;
};
const RadioOption = ({
  name,
  value,
  current,
  onChange,
  label
}: {
  name: string;
  value: string;
  current: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}) => <label className="flex items-center gap-3 cursor-pointer group" data-id="element-38">
    <input type="radio" name={name} value={value} checked={current === value} onChange={onChange} className="sr-only peer" data-id="element-39" />
    <span className="w-4 h-4 rounded-full border border-taupe flex items-center justify-center transition-colors peer-checked:border-stone" data-id="element-40">
      <span className={`w-2 h-2 rounded-full transition-colors ${current === value ? 'bg-stone' : 'bg-transparent'}`} data-id="element-41" />
    </span>
    <span className="text-sm text-stone" data-id="element-42">{label}</span>
  </label>;